import { setDraggingCursor } from "@v1/reducers/drag-and-drop-reducer";
import { useEditorDispatch, useEditorSelector } from "@v1/store/store";

export default function useDraggingCursor() {
  const draggingCursor = useEditorSelector(
    (state) => state.dragAndDrop.draggingCursor,
  );
  const dispatch = useEditorDispatch();

  return {
    draggingCursor,
    setDraggingCursor: (draggingCursor: string | null) => {
      return dispatch(setDraggingCursor(draggingCursor));
    },
  };
}
